// Encapsulate code in Immediately Invoked Functional Expression
(function() {

  // Invoke strict mode
  "use strict";

  /**
   * Object of DOM element references for the UI.
   *
   * @object ui
   */
  var ui = {};

  /**
   * Object to handle block related functionality.
   *
   * @object block
   */
  var block = {

    /**
     * Property to flag when in mobile view.
     *
     * @property block.mobile
     */
    mobile: window.innerWidth < 1024,

    /**
     * Property to flag when menu is open.
     *
     * @property block.open
     */
    open: false,

    /**
     * Method to handle block initialization.
     *
     * @method block.init
     */
    init: function() {

      // Get all tab blocks on the page
      ui = {
        blocks: doms("nav[role='navigation']"),
        navigation: dom(".navigation-global"),
        links: {
          primary: doms(".navigation-primary .navigation-item"),
        },
        header: {
          container: dom(".header"),
          wrapper: dom(".header > .wrapper"),
          home: dom(".header-logo a"),
        },
        contact: {
          navigation: dom(".navigation-contact"),
          toggles: doms(".navigation-contact-toggle"),
        },
      };

      block.bind();

    },

    /**
     * Method to handle binding to the DOM elements.
     *
     * @method block.bind
     */
    bind: function(parent) {

      // Bind the handler to the key down event on the document
      document.addEventListener("keydown", block.keydown);

      // Bind the handler to the window resize event
      window.addEventListener("resize", function(event) {
        block.mobile = window.innerWidth < 1024;
      });

      // Replace the nav toggles with a button
      var toggles = doms(".navigation-toggle");
      for (var i = 0; i < toggles.length; i++) {
        toggles[i].parentNode.removeChild(toggles[i]);
      }

      var button = document.createElement("button");
      button.classList.add("navigation-toggle", "open");
      button.setAttribute("aria-haspopup", "true");
      button.setAttribute("aria-expanded", "false");
      button.onclick = function(event) {
        if (!block.mobile) {
          return;
        }
        event.preventDefault();
        var active = event.target.getAttribute("aria-expanded") == "true";
        block.open = !active;
        event.target.setAttribute("aria-expanded", active ? "false" : "true");
        if (active) {
          ui.header.container.classList.remove("active");
        } else {
          ui.header.container.classList.add("active");
        }
        event.target.classList.remove(active ? "close" : "open");
        event.target.classList.add(active ? "open" : "close");
        document.body.style.overflow = active ? "auto" : "hidden";
      };

      // TODO: Get the text from the CMS/DOM
      button.innerHTML = ui.navigation.getAttribute("data-label-toggle");
      ui.header.wrapper.appendChild(button);

      // Handle hover in/out of primary nav on desktop
      for (var i = 0; i < ui.links.primary.length; i++) {
        // Handle on mouse over
        ui.links.primary[i].onmouseover = function(event) {
          if (block.mobile) {
            return;
          }
          event.target.setAttribute("aria-expanded", "true");
          var submenu = dom(".sub-navigation", event.target.parentNode);
          if (!submenu) {
            return;
          }
          var subsubs = doms(".sub-navigation-item", submenu);
          for (var ii = 0; ii < subsubs.length; ii++) {
            subsubs[ii].setAttribute("aria-expanded", "true");
          }
        }
        // Handle on mouse out
        ui.links.primary[i].onmouseout = function(event) {
          if (block.mobile) {
            return;
          }
          event.target.setAttribute("aria-expanded", "false");
          var submenu = dom(".sub-navigation", event.target.parentNode);
          if (!submenu) {
            return;
          }
          var subsubs = doms(".sub-navigation-item", submenu);
          for (var ii = 0; ii < subsubs.length; ii++) {
            subsubs[ii].setAttribute("aria-expanded", "false");
          }
        }
      }

      // Handle click of menu buttons on mobile
      var links = doms([
        ".navigation-primary .navigation-item",
        ".navigation-primary .sub-navigation-item",
      ].join(","));
      for (var i = 0; i < links.length; i++) {
        links[i].onclick = function(event) {
          if (!block.mobile) {
            return;
          }
          var children = dom("[role='region']", event.target.parentNode);
          if (!children) {
            return;
          }
          event.preventDefault();
          var active = event.target.getAttribute("aria-expanded") == "true";
          event.target.setAttribute("aria-expanded", active ? "false" : "true");
        };
      }

      // Handle creating Overview links for mobile menu
      var links = doms(".navigation-item[aria-haspopup='true']");
      for (var index = 0; index < links.length; index++) {
        var link = links[index];
        var wrapper = dom(".sub-navigation-wrapper", link.parentElement);
        var item = document.createElement("li");
        var anchor = document.createElement("a");
        anchor.href = link.href;
        anchor.innerHTML = ui.navigation.getAttribute("data-label-overview");
        anchor.className = "sub-navigation-item";
        anchor.setAttribute("role", link.getAttribute("role"));
        anchor.setAttribute("tabindex", link.getAttribute("tabindex"));
        if (link.getAttribute("aria-current") === "page") {
          anchor.setAttribute("aria-current", "page");
        }
        item.className = "navigation-overview";
        item.setAttribute("role", "presentation");
        item.appendChild(anchor);
        wrapper.insertBefore(item, wrapper.firstChild);
      }

      // Handle creating Overview links for mobile menu
      var links = doms(".sub-navigation-item[aria-haspopup='true']");
      for (var index = 0; index < links.length; index++) {
        var link = links[index];
        var wrapper = dom(".sub-sub-navigation-wrapper", link.parentElement);
        var item = document.createElement("li");
        var anchor = document.createElement("a");
        anchor.href = link.href;
        anchor.innerHTML = ui.navigation.getAttribute("data-label-overview");
        anchor.className = "sub-sub-navigation-item";
        anchor.setAttribute("role", link.getAttribute("role"));
        anchor.setAttribute("tabindex", link.getAttribute("tabindex"));
        if (link.getAttribute("aria-current") === "page") {
          anchor.setAttribute("aria-current", "page");
        }
        item.className = "navigation-overview";
        item.setAttribute("role", "presentation");
        item.appendChild(anchor);
        wrapper.insertBefore(item, wrapper.firstChild);
      }

      // Handle the contact/help menu
      var active = false;
      for (var index = 0; index < ui.contact.toggles.length; index++) {
        var toggle = ui.contact.toggles[index];
        toggle.onclick = function(event) {
          event.preventDefault();
          if (window.innerWidth < 1024) {
            active = !active;
            dom(".wrapper > .navigation-contact-toggle").classList.toggle("active");
            ui.contact.navigation.classList.toggle("active");
          }
        };
      }

    },

    /**
     * Method to handle the block with the keyboard input.
     *
     * @method block.keydown
     */
    keydown: function(event) {

      var key = event.which;

      // Get the active element
      var active = document.activeElement;
      var classes = active.classList;
      // If going backwards, shift is true
      var shift = !!event.shiftKey;

      // Switch logic based on key pressed
      switch(key) {

        // Handle on press of the enter/return key
        case config.keys.ESC:

          var isNavItem = classes.contains("navigation-item");
          var isSubNavItem = classes.contains("sub-navigation-item");
          var isSubSubNavItem = classes.contains("sub-sub-navigation-item");

          // Handle closing the menu when open
          if (classes.contains("navigation-toggle") && block.open) {
            active.click();
          }

          // Handle closing the menu when open
          if (isNavItem || isSubNavItem || isSubSubNavItem) {
            if (block.mobile) {
              dom(".navigation-toggle").focus();
            } else {
              var list = block.getArrayFromDomNodeList(ui.links.primary);
              var index = list.indexOf(active);
              if (isSubNavItem) {
                index = list.indexOf(
                  // HACK: Fix this terrible line!
                  dom(".navigation-item", active.parentNode.parentNode.parentNode.parentNode)
                );
              } else if (isSubSubNavItem) {
                index = list.indexOf(
                  // HACK: Fix this terrible, terrible line!
                  dom(".navigation-item", active.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode)
                );
              }
              if (index < list.length - 1) {
                list[index + 1].focus();
              } else {
                dom(".navigation-search").focus();
              }
            }
          }

          break;

        // Handle on press of the enter/return key
        case config.keys.TAB:

          // Handle tabbing across top level navigation
          if (classes.contains("navigation-item")) {
            block.getChildLinksFromParent(active)[0].focus();
          }

          // Handle tabbing into the menu when open
          if (classes.contains("navigation-toggle") && block.open) {
            event.preventDefault();
            window.setTimeout(function() {
              dom(".navigation-item").focus();
            }, 150);
          }

          break;

      }

    },

    /**
     * Method to get all sub links from a parent link.
     *
     * @method block.getChildLinksFromParent
     */
    getChildLinksFromParent: function(link) {

      var id = link.getAttribute("aria-controls");
      var parent = dom("#" + id);
      var links = doms("a", parent);

      return block.getArrayFromDomNodeList(links);

    },

    /**
     * Method to turn a list of DOM nodes into an array.
     *
     * @method block.getArrayFromDomNodeList
     */
    getArrayFromDomNodeList: function(elements) {

      var list = [];

      for (var index = 0; index < elements.length; index++) {
        list.push(elements[index]);
      }

      return list;

    },

  };

  // Bind the init to the global block init event
  rgc.events.on("rgc.blocks.init", block.init.bind(block));

})();
